import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AbogadosService} from '../../service/abogados.service';
import {AbogadoMessage} from '../../domain/abogado-message';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {GlobalAppService} from '../../../core/commons/global-app.service';
import {AbogadoContact} from '../../domain/abogado-contact';

@Component({
    selector: 'abogado-message-editor',
    templateUrl: './message-editor.component.html',
    styleUrls: ['./message-editor.component.scss']
})
export class MessageEditorComponent {
    // chips
    visible = true;
    selectable = false;
    removable = false;
    addOnBlur = false;
    readonly separatorKeysCodes: number[] = [COMMA, ENTER];

    abogados: AbogadoContact[];

    abogadosChips: string[] = [];

    @Output() onSent = new EventEmitter<boolean>();

    messageForm: FormGroup;

    constructor(private fb: FormBuilder, private service: AbogadosService, private appService: GlobalAppService) {
        this.messageForm = fb.group({
            title: ['', Validators.required],
            body: ['', Validators.required]
        });
    }

    send() {
        this.appService.setLoading(true);
        let message = new AbogadoMessage({
            title: this.messageForm.value.title,
            body: this.messageForm.value.body
        });
        message.setUsersEmails(this.abogados.map(a => a.email));
        this.service.sendMessage(message)
            .subscribe(res => {
                this.onSent.emit(res);
                this.appService.setLoading(false);
            });
    }

    @Input("abogados")
    set abogadosContactInfo(val: AbogadoContact[]) {
        this.abogados = val;
        if (this.abogados.length > 5) {
            this.abogadosChips = this.abogados.slice(0, 4).map(a => a.email);
            this.abogadosChips.push((this.abogados.length - 4) + ' más');
        } else {
            this.abogadosChips = this.abogados.map(a => a.email);
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/message-editor/message-editor.component.ts